<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    width="400px"
    height="300px"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="accountGrid.gridOptions"
      :column-defs="accountGrid.columnDefs"
      :row-data="accountGrid.rowData"
      style="width:100%;height:200px;"
      @gridReady="gridParams=>accountGrid.gridApi=gridParams.api"
    />
    <div slot="footer">
      <el-radio-group v-model="groupAr" @change="jobChanged">
        <el-radio :label="1">{{ $t('CargoMsg.Cargo_Revenue') }}</el-radio>
        <el-radio :label="0">{{ $t('CargoMsg.Cargo_PrimeCost') }}</el-radio>
      </el-radio-group>
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Copy2') }}</el-button>
      <el-button type="primary" @click="visible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'

export default {
  name: 'CopySlaveCostDialog',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true },
    uuidPrefixRule: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      job: {},
      groupAr: 1,
      title: this.$t('SeaExport.CopySmallTicketCost'),
      accountGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        gridApi: null,
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SettlementCompany'),
            field: 'accountId',
            width: 500,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          }
        ],
        rowData: []
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.job = this.params
        this.jobChanged()
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    // 单选变更处理
    async jobChanged() {
      await this.job.getLclSlaves()
      const accountIds = await ChargeUtils.groupingSlaveChargeAccountId(this.job.lclSlaves, this.isAr())
      const list = []
      for (const accountId of accountIds) {
        list.push({ 'selected': false, 'accountId': accountId })
      }
      this.accountGrid.rowData = list
    },
    // 抄录校验
    validate() {
      if (this.accountGrid.rowData === null || this.accountGrid.rowData.length === 0) {
        this.$message.info('没有可抄录的成本.')
        return false
      } else {
        const hasSelected = this.accountGrid.gridApi.getSelectedRows() !== null
        if (!hasSelected) {
          this.$message.info(this.$t('SeaExport.PleaseCostToBeCopied'))
          return false
        }
      }
      return true
    },
    // 抄录
    async saveHandler() {
      if (this.validate()) {
        const accountIds = []
        const selectedRows = this.accountGrid.gridApi.getSelectedRows()
        for (const item of selectedRows) {
          accountIds.push(item.accountId)
        }
        const charges = await ChargeUtils.copySlaveCostToMaster(this.job, accountIds, this.isAr(), this.uuidPrefixRule)
        this.innerVisible = false
        this.$emit('success', charges)
      }
    },
    isAr() {
      return this.groupAr === 1
    }
  }
}
</script>

<style scoped>

</style>
